import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
} from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Data } from "./../../shared/data";
import { NextaSelectionBaseReactiveForm } from "../../shared/nexta-crud/nexta-selection-reactive-form";
import { NextaFileReader } from "../../shared/nexta-file-reader";
import { NotificationService } from "../../shared/notification.service";
import { PrivateKeyService } from "./crud.service";
import { PrivateKey } from "./private-key";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "./private-key-form.component.html",
	standalone: false,
})
export class PrivateKeyFormComponent extends NextaSelectionBaseReactiveForm<PrivateKey> {
	file: File;

	constructor(
		router: Router,
		private privateKeyService: PrivateKeyService,
		notify: NotificationService,
		route: ActivatedRoute,
		acrossPagesData: Data,
		cdr: ChangeDetectorRef,
	) {
		super(
			"edit",
			router,
			privateKeyService,
			notify,
			route,
			cdr,
			null,
			acrossPagesData,
		);
	}

	initFormGroup() {
		const fb = new UntypedFormBuilder();
		this.form = fb.group({
			id: [""],
			file: ["", Validators.required],
			pinP12: [""],
			pinKey: [""],
		});
	}

	transform(data: any): any {
		const formData = new FormData();
		formData.append("file", this.file);
		formData.append("pinP12", data.pinP12);
		formData.append("pinKey", data.pinKey);
		return formData;
	}

	navigateToOnSubmitSuccess() {
		this.router.navigate([
			"/schluessel/private-schluessel",
			this.form.getRawValue().id,
		]);
	}

	onFileSelected(event: any) {
		const file = event.target.files[0];
		this.file = file;
		const fileReader: NextaFileReader = new NextaFileReader(this.form, "file");
		fileReader.readAsArrayBuffer(file);
	}

	/**
	 * Besonderheit hier: Es wird an einem anderen Endpunkt gespeichert als normalerweise.
	 */
	onSubmit() {
		this.beforeSubmit();

		this.form.updateValueAndValidity();

		if (!this.form.valid) {
			this.cdr.markForCheck();
			return;
		}

		const data = this.transform(this.form.value);

		// ID setzen, da diese sich nicht im Formular befindet
		if (this.route.snapshot.params.id !== undefined) {
			data.id = this.route.snapshot.params.id;
		}

		this.privateKeyService
			.saveAtSpecialEndpoint(data, this.endpoint)
			.subscribe((response) => {
				if (response) {
					this.patchValue(response);
				}

				this.onSubmitSuccess(response);
				this.cdr.markForCheck();
			});
	}
}
